import { render, staticRenderFns } from "./PaginaAdminTiposEmpresa.vue?vue&type=template&id=586db5d6&lang=true"
import script from "./PaginaAdminTiposEmpresa.vue?vue&type=script&lang=js"
export * from "./PaginaAdminTiposEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports